
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import onClickOutside from 'react-onclickoutside';

import {
    display,
    input,
    position,
    width
} from '../../../../../../commonStyles.js';
import styles from '../styles.js';

import Translatable from '../../../../../../components/Translatable';

class LocationInput extends Component {
    static propTypes = {
        locationInput: PropTypes.object.isRequired,
        onHideLocationInput: PropTypes.func.isRequired,
        onLocationChange: PropTypes.func.isRequired,
        onShowLocationInput: PropTypes.func.isRequired
    }

    handleClickOutside = () => {
        const {
            onHideLocationInput
        } = this.props;
        onHideLocationInput();
    }

    handleLocationChange = e => {
        const value = e.target.value;
        this.props.onLocationChange(value);
    }

    handleShowLocationInput = () => {
        this.props.onShowLocationInput();
    }

    render() {
        return (
            <div id="location_input">
                <div className={css(position.relative)}>
                    <div className={css(display.block, width.fullWidth)}>
                        <label
                            className={css(styles.hiddenLabel)}
                            htmlFor="autocomplete_SearchBarLarge"
                        >
                            <Translatable
                                content={{
                                    transKey: 'common.where'
                                }}
                            />
                        </label>
                        <div className={css(styles.container, styles.container_noMargins)}>
                            <div
                                style={{
                                    display: 'table',
                                    width: '100%'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'table-cell',
                                        verticalAlign: 'middle'
                                    }}
                                >
                                    <div className={css(styles.prefixContainer)}>
                                        <div className={css(styles.prefix)}>
                                            <div>
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    role="presentation"
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    style={{
                                                        display: 'block',
                                                        fill: 'rgb(118, 118, 118)',
                                                        height: '18px',
                                                        width: '18px'
                                                    }}
                                                >
                                                    <path
                                                        d="M10.4 18.2c-4.2-.6-7.2-4.5-6.6-8.8.6-4.2 4.5-7.2 8.8-6.6 4.2.6 7.2 4.5 6.6 8.8-.6 4.2-4.6 7.2-8.8 6.6M23 22l-5-5c1.4-1.4 2.3-3.1 2.6-5.2.7-5.1-2.8-9.7-7.8-10.5-5-.7-9.7 2.8-10.5 7.9-.7 5.1 2.8 9.7 7.8 10.5 2.5.4 4.9-.3 6.7-1.7v.1l5 5c.3.3.8.3 1.1 0 .3-.3.4-.8.1-1.1"
                                                        fillRule="evenodd"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: 'table-cell',
                                        verticalAlign: 'middle'
                                    }}
                                >
                                    <Translatable
                                        attributes={{
                                            placeholder: {
                                                transKey: 'common.where'
                                            }
                                        }}
                                    >
                                        <input
                                            type="text"
                                            autoComplete="off"
                                            className={css(styles.input)}
                                            id="autocomplete_SearchBarLarge"
                                            name="location"
                                            value={this.props.locationInput.value}
                                            onChange={this.handleLocationChange}
                                            onClick={this.handleShowLocationInput}
                                            onFocus={this.handleShowLocationInput}
                                        />
                                    </Translatable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={
                        this.props.locationInput.visible ?
                            css(input.focusUnderline, styles.showUnderline) :
                            css(input.focusUnderline)
                    }
                />
                {
                    this.props.locationInput.visible ?
                        <ul
                            className={css(styles.results)}
                            role="listbox"
                            style={{
                                width: '472px',
                                left: '-1px'
                            }}
                        >
                            {this.props.locationInput.results}
                        </ul> : null
                }
            </div>
        );
    }
}

export default onClickOutside(LocationInput);



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarLarge/LocationInput/LocationInput.jsx